module.exports = __webpack_public_path__ + "img/logo-1.285bfbd4.svg";